import React from "react";
import { Navigate } from "react-router-dom";

// Direct register is no longer the primary path; redirect to the Meet → Save flow.
export default function Register() {
  return <Navigate to="/meet" replace />;
}
